import React, { useEffect, useState } from 'react';

const OfflineBanner: React.FC = () => {
  const [isOnline, setIsOnline] = useState<boolean>(() => {
    if (typeof navigator === 'undefined') return true;
    return navigator.onLine;
  });

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <div className="offline-banner" role="status" aria-live="polite">
      <div className="offline-banner__content">
        <p className="offline-banner__title">You’re offline — showing saved data</p>
        <div className="offline-banner__lists">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-amber-200 mb-1">
              Available now
            </p>
            <ul className="offline-banner__list">
              <li>Cached portfolio balances and allocations</li>
              <li>Previously viewed dashboard, NFT, and risk screens</li>
              <li>Recent history already loaded on this device</li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-amber-200 mb-1">
              Needs internet
            </p>
            <ul className="offline-banner__list">
              <li>Live prices and real-time updates</li>
              <li>Wallet sync and fresh blockchain/NFT fetches</li>
              <li>Exports, uploads, and other write actions</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineBanner;
